var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLocation)?_c('gmap-marker',{attrs:{"position":_vm.currentPosition,"icon":"images/icons/marker--current-location.png"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }